import { normalizeFeatureForUi } from './featureNormalization';

export const emptyPresentationContent = () => ({ features: {} });

export const mergeFeaturePresentation = (feature, catalogContent, overrides = {}) => {
    const name = feature?.name || feature?.Name || '';
    const catalogFeature = catalogContent?.features?.[name];
    const overrideFeature = overrides?.[name];
    const catalogValues = catalogFeature?.values || {};
    const overrideValues = overrideFeature?.values || {};
    const sourceValues = feature?.values || feature?.Values || [];

    const values = sourceValues.map(value => {
        const key = String(value?.value ?? value?.Value ?? '');
        const catalogValue = catalogValues[key] || {};
        const overrideValue = overrideValues[key] || {};
        return {
            ...value,
            value: key,
            displayText: firstText(overrideValue.label, catalogValue.label, value.displayText, value.DisplayText, key),
            description: firstText(overrideValue.description, catalogValue.description, value.description, value.Description, ''),
            imageUrl: firstText(overrideValue.imageUrl, catalogValue.imageUrl, value.imageUrl, value.ImageUrl, ''),
            propertyValues: overrideValue.propertyValues || catalogValue.propertyValues || value.propertyValues || value.PropertyValues || {},
            sortOrder: firstNumber(overrideValue.sortOrder, catalogValue.sortOrder, value.sortOrder, value.SortOrder, 0),
            isDefault: firstBool(overrideValue.isDefault, catalogValue.isDefault, value.isDefault, value.IsDefault)
        };
    }).sort((left, right) => (left.sortOrder - right.sortOrder) || String(left.value).localeCompare(String(right.value)));

    return normalizeFeatureForUi({
        ...feature,
        name,
        displayText: firstText(overrideFeature?.label, catalogFeature?.label, feature?.displayText, feature?.DisplayText, feature?.property?.displayText, name),
        description: firstText(overrideFeature?.description, catalogFeature?.description, feature?.description, feature?.Description, ''),
        inputType: firstText(overrideFeature?.inputType, catalogFeature?.inputType, feature?.inputType, feature?.type, feature?.property?.type, 'dropdown'),
        valueSchema: overrideFeature?.valueSchema || catalogFeature?.valueSchema || feature?.valueSchema || feature?.property?.valueSchema || [],
        cardLayout: overrideFeature?.cardLayout || catalogFeature?.cardLayout || feature?.cardLayout || feature?.property?.cardLayout || null,
        values
    });
};

export const countDesignOverrides = (overrides, pages) => {
    let count = 0;
    Object.values(overrides || {}).forEach(feature => {
        if (!feature || typeof feature !== 'object') return;
        if (String(feature.label || '').trim()) count += 1;
        if (String(feature.inputType || '').trim()) count += 1;
        Object.values(feature.values || {}).forEach(value => {
            if (!value || typeof value !== 'object') return;
            if (String(value.label || '').trim()) count += 1;
            if (String(value.imageUrl || '').trim()) count += 1;
        });
    });
    (pages || []).forEach(page => {
        (page.elements || []).forEach(element => {
            if ((element.type === 'feature' || element.type === 'variable') && String(element.renderType || '').trim()) {
                count += 1;
            }
        });
    });
    return count;
};

export const featureStatus = (feature, catalogFeature) => {
    const values = feature?.values || [];
    const catalogValues = catalogFeature?.values || {};
    const missing = values.filter(value => {
        const entry = catalogValues[value.value];
        return !entry || !String(entry.label || '').trim();
    });
    const unused = Object.keys(catalogValues).filter(key => !values.some(value => value.value === key));
    return {
        incomplete: missing.length > 0 || !String(catalogFeature?.label || '').trim(),
        unused: unused.length > 0,
        missingCount: missing.length,
        unusedCount: unused.length
    };
};

const firstText = (...values) => {
    const found = values.find(value => value !== undefined && value !== null && String(value).trim() !== '');
    return found === undefined || found === null ? '' : String(found);
};

const firstNumber = (...values) => {
    const found = values.find(value => value !== undefined && value !== null && value !== '');
    const number = Number(found);
    return Number.isFinite(number) ? number : 0;
};

const firstBool = (...values) => Boolean(values.find(value => value !== undefined && value !== null));
